import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

import { ReactComponent as ArrowDownIcon } from '../../../Assets/arrowDown.svg'
import { ReactComponent as ArrowUpIcon } from '../../../Assets/arrowUp.svg'
import { useDeviceDetector } from '../../../Hooks/useDeviceDetector'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
  selectedData?: any
  setSelectedData?: any
}

/**
 * TabSelector Component
 */

const TabSelector = ({ content, selectedData, setSelectedData }: Props) => {
  const { isMobile } = useDeviceDetector()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const toggleClick = (e, parentName: string, parentId: string, childId: string) => {
    e.preventDefault()
    e.stopPropagation()
    const obj = {
      parentId: parentId,
      parentName: parentName,
      childId: childId,
      childName: e.target.textContent,
    }
    const selected = selectedData.map((values) => {
      if (values.parentId === parentId) {
        return obj
      }
      return values
    })
    setSelectedData(selected)
  }

  const toggleMobileTabs = (e: any) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
    // const parentEle = e.target.closest(".mobileSelectedTab");
    // parentEle.classList.toggle("active");
    // parentEle.nextElementSibling.classList.toggle("active");
  }

  const selectTab = (e: any, parentName: string, parentId: string, childId: string) => {
    e.stopPropagation()
    const parentEle = e.target.closest('.tabs')
    const tabSelector = e.target.closest('.mobileTab')
    const mobileSelectedTab = tabSelector.querySelector('.mobileSelectedTab')
    const text = parentEle.children[0].textContent
    mobileSelectedTab.querySelector('.selected p').innerHTML = text
    mobileSelectedTab.classList.toggle('active')
    mobileSelectedTab.nextElementSibling.classList.toggle('active')
    const obj = {
      parentId: parentId,
      parentName: parentName,
      childId: childId,
      childName: text,
    }
    const selected = selectedData.map((values) => {
      if (values.parentId === parentId) {
        return obj
      }
      return values
    })
    setSelectedData(selected)
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  return (
    <div className="news-tabSelector">
      {content?.childItems.length <= 3 && (
        <div className={`tabHeading`}>
          {!isMobile ? (
            <>
              <Paragraph content={content.parentName} classes="pb-16" />
              <div className="flex">
                {content?.childItems?.map((item, index) => (
                  <div
                    ref={dropdownRef}
                    key={`${item.sys.id}-${index}`}
                    className={`tabs cursor-pointer overflow-hidden border border-neutral-50 px-24 py-16 ${
                      content.childItems.length === 1
                        ? 'rounded-lg'
                        : index === 0
                          ? 'rounded-bl-lg rounded-tl-lg border-r'
                          : index === content.childItems?.length - 1
                            ? 'border-r-none rounded-br-lg rounded-tr-lg'
                            : ''
                    } ${
                      selectedData.filter((selected) => selected.parentId === content.parentId)[0].childName ===
                      item.prefLabel['en-US']
                        ? 'active'
                        : ''
                    }`}
                    onClick={(e) => {
                      toggleClick(e, content.parentName, content.parentId, item.sys.id)
                    }}
                  >
                    <Paragraph content={item.prefLabel['en-US']} />
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className={`mobileTab relative w-full`} ref={dropdownRef}>
              <Paragraph content={content.parentName} classes="pb-16" />
              <div
                className={`mobileSelectedTab flex w-full items-center justify-between overflow-hidden rounded-lg border border-neutral-50 p-16 md:min-w-[340px] ${
                  isOpen && 'active'
                }`}
                onClick={(e) => {
                  toggleMobileTabs(e)
                }}
              >
                <div className={`selected flex cursor-pointer items-center justify-start gap-12`}>
                  <Paragraph
                    content={selectedData.filter((selected) => selected.parentId === content.parentId)[0].childName}
                  />
                </div>
                <div className="">
                  <ArrowUpIcon />
                  <ArrowDownIcon />
                </div>
              </div>
              <div
                className={`mobileTabHeading absolute left-0 top-full z-10 flex max-h-[225px] w-full flex-col overflow-hidden rounded-bl-lg rounded-br-lg border border-neutral-50 bg-white shadow-xl ${
                  isOpen && 'active'
                }`}
              >
                {content?.childItems?.map((item, index) => (
                  <div
                    key={`${item.sys.id}-${index}`}
                    className={`tabs cursor-pointer border border-t-0 border-neutral-50 p-16`}
                    onClick={(e) => {
                      selectTab(e, content.parentName, content.parentId, item.sys.id)
                    }}
                  >
                    <Paragraph content={item.prefLabel['en-US']} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {content?.childItems.length > 3 && (
        <div className={`tabHeading flex`}>
          <div className={`mobileTab relative w-full`} ref={dropdownRef}>
            <Paragraph content={content.parentName} classes="pb-16" />
            <div
              className={`mobileSelectedTab flex w-full items-center justify-between overflow-hidden rounded-lg border border-neutral-50 p-16 md:min-w-[340px] ${
                isOpen && 'active'
              }`}
              onClick={(e) => {
                toggleMobileTabs(e)
              }}
            >
              <div className={`selected flex cursor-pointer items-center justify-start gap-12`}>
                <Paragraph
                  content={selectedData.filter((selected) => selected.parentId === content.parentId)[0].childName}
                />
              </div>
              <div className="">
                <ArrowUpIcon />
                <ArrowDownIcon />
              </div>
            </div>
            <div
              className={`mobileTabHeading absolute left-0 top-full z-10 flex max-h-[225px] w-full flex-col overflow-hidden rounded-bl-lg rounded-br-lg border border-neutral-50 bg-white shadow-xl ${
                isOpen && 'active'
              }`}
            >
              {content?.childItems?.map((item, index) => (
                <div
                  key={`${item.sys.id}-${index}`}
                  className={`tabs cursor-pointer border border-t-0 border-neutral-50 p-16`}
                  onClick={(e) => {
                    selectTab(e, content.parentName, content.parentId, item.sys.id)
                  }}
                >
                  <Paragraph content={item.prefLabel['en-US']} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TabSelector
